<template>
	<div>
		<div class="form-group d-flex align-items-center">
			<h1 class="col-xs-11">
				Orders
			</h1>
			<form class="form-inline d-flex ml-auto col-xs-11">
				<input autofocus class="form-control form-control-sm" type="text" placeholder="Search By Name"
					v-model="fullname" />
				<button class="btn btn-primary btn-sm ml-1" type="button" @click="Clear()">Clear</button>
			</form>
		</div>

		<div class="alert alert-danger" v-if="error">
			<p class="mb-0">
				{{ error }}
			</p>
		</div>

		<datatable class="mt-4" :cols="columns" style="height: 70vh;"
			:rows="orders.filter(c => fullname ? c.fullname.toLowerCase().includes(fullname.toLowerCase()) : true)" />

	</div>
</template>

<script>
import store from '../../../store';
import { mapGetters, mapState } from 'vuex';
import DataTable from '../../DataTable';
import { createDatatableButtons, createDropDown, getError } from '../../../helpers';
import ret from 'bluebird/js/release/util';


export default {
	components: {
		'datatable': DataTable,
	},

	data() {
		return {
			fullname: null,
			error: null,

			columns: [
				{ headerName: 'ID', field: 'id', sortable: true, filter: true, resizable: true, minWidth: 50, maxWidth: 75 },
				{ headerName: 'User', field: 'cart.user.fullname', sortable: true, filter: true, resizable: true, minWidth: 150, maxWidth: 300 },
				{ headerName: 'Created At', field: 'created_at', sortable: true, filter: true, resizable: true, minWidth: 100, maxWidth: 150 },
				{
					headerName: 'Total',
					field: 'total_after_shipping',
					minWidth: 100,
					maxWidth: 150,
					cellRenderer: params => params.value ? Number(params.value).toFixed(2) + ' $' : params.value
				},
				{
					headerName: 'Payment Type',
					field: 'payment_type',
					minWidth: 120,
					maxWidth: 150,
					// cellRenderer: params => {
					// 	switch (params.value) {
					// 		case '0':
					// 			return 'Cash';
					// 		case '1':
					// 			return 'Sadad';
					// 		case '2':
					// 			return 'MasterCard'
					// 		case '3':
					// 			return 'Visa';
					// 		case '4':
					// 			return 'Mada';
					// 		case null:
					// 			return 'N/A';
					// 	}
					// },
				},
				{
					headerName: 'Status',
					field: 'paid',
					minWidth: 110,
					maxWidth: 150,
					cellRenderer: params => params.value ? 'Paid' : 'Unpaid',
				},
				{
					headerName: 'Current Status',
					field: 'status',
					minWidth: 150,
					maxWidth: 200,
					cellRenderer: params => {
						switch (params.value) {
							case 0:
								return 'Approved';
							case 1:
								return 'In preparation';
							case 2:
								return 'Shipping';
							case 3:
								return 'Delivery';
							case 4:
								return 'Canceled';
							case 6:
								return 'Waiting'
						}
					},
				},
				{
					headerName: 'Actions',
					field: 'id',
					minWidth: 150,
					maxWidth: 250,

					cellRenderer: params => {

						const buttons = [{
							name: params.data.paid ? 'Unpay' : 'Pay',
							type: 'success',
							disabled: params.data.status === 4 ? true : false,
							handler: () => {
								if (confirm('Are you sure you want to set toggle the payment status of this order?')) {
									this.error = null;

									this.$store.dispatch('orders/paid', { orderId: params.value, paid: !params.data.paid })
										.catch(e => {
											this.error = getError(e);
										});
								}
							},
						}];

						// if (params.value.payment_type == null || // N/A
						// 	params.value.payment_type == '0' || // Cash
						// 	params.value.payment_type == '1') // Sadad

						// name: params.data.status == null ? 'Approved' : params.data.status == 0 ? 'In preparation' : params.data.status == 1 ? 'Shipping' : params.data.status = 2 ? 'Delivered' :
						// 	params.data.status == 3 ? 'Delivered' : 'Delivered',
						// type: 'info',
						// disabled: params.data.status == 3 ? true : params.data.status == 4 ? true : false,
						// handler: () => {
						// 	if (confirm('Are you sure you want to change order status?')) {
						// 		this.error = null;

						// 		this.$store.dispatch('orders/status', { orderId: params.value })
						// 			.catch(e => {
						// 				this.error = getError(e);
						// 			})
						// 	}
						// },
						buttons.push({
							name: 'View',
							type: 'secondary',
							handler: () => {
								this.$router.push({ name: 'view-order', params: { id: params.value } });
							},
						});

						buttons.push({
							name: 'Cancel',
							type: 'danger',
							disabled: params.data.status <= 2 ? false : params.data.status === 6 ? false : true,
							handler: () => {
								if (confirm('Are you sure you want to Cancel this Order?')) {
									this.error = null;

									this.$store.dispatch('orders/cancel', { orderId: params.value, paid: !params.data.paid })
										.catch(e => {
											this.error = getError(e);
										});
								}
							},
						});

						return createDatatableButtons(buttons);
					}
				},
				{
					headerName: "Status Action",
					field: 'id',
					minWidth: 100,
					maxWidth: 225,
					cellRenderer: params => {
						var createButton = (className, text) => {
							const btn = document.createElement('button');
							btn.className = className;
							btn.innerText = text;
							return btn;
						}

						const div = document.createElement('div');
						const btns = [];
						const states = [{ id: 0, name: 'Approved' }, { id: 1, name: 'In preparation' }, { id: 2, name: 'Shipping' }, { id: 3, name: 'Delivered' }]
						let currentStatus = params.data.status
						const currentStateText =
							params.data.status == 6
								? 'Approved' : params.data.status == 0
									? 'Approved' : params.data.status == 1
										? 'In preparation' : params.data.status == 2
											? 'Shipping' : params.data.status == 3 
											? 'Delivered' : 'Delivered'
						const btnsText = ['<', currentStateText, '>'];
						btnsText.forEach((text, index) => {
							btns.push(createButton('btn mr-1 btn-ag-grid', text))
							div.append(btns[index]);
						});

						btns[1].classList.add('btn-info');

						btns[0].addEventListener('click', (e) => {
							e.preventDefault();
							let btnSelector = btns[1];
							if (states[currentStatus].name !== btnSelector.innerText) {
								btnSelector.classList.remove('btn-info');
								btnSelector.classList.add('btn-outline-info');
							}
							else {
								btnSelector.classList.remove('btn-outline-info');
								btnSelector.classList.add('btn-info');
							}

							if ((currentStatus - 1) < 0) {
								btns[0].classList.add('disabled');
							}
							else {
								btns[0].classList.remove('disabled');
								btnSelector.innerText = states[--currentStatus].name;
							}
						})


						btns[2].addEventListener('click', (e) => {
							e.preventDefault();
							let btnSelector = btns[1];
							if (states[currentStatus].name !== btnSelector.innerText) {
								btnSelector.classList.remove('btn-info');
								btnSelector.classList.add('btn-outline-info');
							}
							else {
								btnSelector.classList.remove('btn-outline-info');
								btnSelector.classList.add('btn-info');
							}

							if ((currentStatus + 1) >= 4) {
								btns[2].classList.add('disabled');
							}
							else {
								btns[2].classList.remove('disabled');
								btnSelector.innerText = states[++currentStatus].name;
							}
						})

						btns[1].addEventListener('click', (e) => {
							e.preventDefault();
							if (confirm('Are you sure you want to change order status?')) {
								this.error = null;
								this.$store.dispatch('orders/status', { orderId: params.value, currentStatus: states[currentStatus].id })
									.catch(e => {
										this.error = getError(e);
									})
							}
						})
						return div;
					}
				},

			],
		};
	},

	computed: {
		...mapState({
			orders: state => state.orders.orders.map(c => ({ ...c })),
		}),
		...mapGetters({
			getIndexById: 'orders/getIndexById'
		})
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('orders/fetchAll');
		next();
	},
	methods: {
		Clear() {
			this.user_name = null;
		}
	},

	meta: {
		title: 'Orders',

		meta: [
			{ property: 'og:title', content: 'Orders / Al-Shayah' },
		],
	},
};
</script>